import { FieldRootBaseProps, FieldRootProps } from "@ark-ui/react";
import {
  forwardRef,
  ReactNode,
  PropsWithChildren,
  RefAttributes,
  ElementRef,
  ReactElement,
} from "react";
import { FieldHint } from "./FieldHint";
import { FieldLabel } from "./FieldLabel";
import { AromaFieldVariantProps } from "@zenchef/styled-system/recipes/aroma-field";
import { StatusType } from "./types";
import { FieldRoot } from "./fieldParts";
import { HTMLStyledProps } from "@zenchef/styled-system/types";

export interface FieldProps
  extends AromaFieldVariantProps,
    PropsWithChildren,
    FieldRootProps,
    FieldRootBaseProps,
    Omit<HTMLStyledProps<"div">, "color" | "content" | "translate"> {
  errorMessage?: string;
  label?: ReactNode;
  description?: ReactNode;
  tooltipText?: string;
  hint?: ReactNode;
  status?: StatusType;
}

const Field = forwardRef<HTMLDivElement, FieldProps>(
  (
    { label, description, children, hint, tooltipText, errorMessage, ...props },
    ref,
  ) => (
    <FieldRoot
      ref={ref}
      {...props}
      invalid={!!errorMessage}
      status={errorMessage ? "error" : props.status}
    >
      {label ? (
        <FieldLabel description={description} tooltip={tooltipText}>
          {label}
        </FieldLabel>
      ) : null}
      {children}
      {(errorMessage ?? hint) ? (
        <FieldHint status={errorMessage ? "error" : props.status}>
          {errorMessage ?? hint}
        </FieldHint>
      ) : null}
    </FieldRoot>
  ),
) as (props: FieldProps & RefAttributes<ElementRef<"div">>) => ReactElement;

export default Object.assign(Field, {
  Root: FieldRoot,
  Label: FieldLabel,
  Hint: FieldHint,
});
